const VALIDATION_STATUSES = {
  VALID: "valid",
  INVALID: "invalid",
  EMPTY: "empty",
};

const EVENTS = {
  // ready
  READY: "ready",
  // frame
  FRAME_ACTIVATED: "frameActivated",
  FRAME_FOCUS: "frameFocus",
  FRAME_BLUR: "frameBlur",
  FRAME_VALIDATION_CHANGED: "frameValidationChanged",
  VALUE_CHANGED: "valueChanged",
  // payment method
  PAYMENT_METHOD_CHANGED: "paymentMethodChanged",
  // card
  CARD_VALIDATION_CHANGED: "cardValidationChanged",
  CARD_SUBMITTED: "cardSubmitted",
  CARD_TOKENIZED: "cardTokenized",
  CARD_TOKENIZATION_FAILED: "cardTokenizationFailed",
  CARD_BIN_CHANGED: "cardBinChanged",
};

// elements
const ELEMENTS = {
  CARD_NUMBER: "card-number",
  EXPIRY_DATE: "expiry-date",
  CVV: "cvv",
  SCHEME_CHOICE: "scheme-choice",
};

const ELEMENT_FRAMES = {
  CARD_NUMBER: "cardNumber",
  EXPIRY_DATE: "expiryDate",
  CVV: "cvv",
  SCHEME_CHOICE: "schemeChoice",
};

const STANDARD_CVV_LENGTH = 3;
const AMEX_CVV_LENGTH = 4;
const AMEX_SCHEME = "American Express";

const FRAMES_MODES = {
  DISABLE_COPY_PASTE: "disable_copy_paste",
  CVV_HIDDEN: "cvv_hidden",
  CVV_OPTIONAL: "cvv_optional",
  DISABLE_AUTO_FOCUS: "disable_auto_focus",
  RIGHT_TO_LEFT: "right_to_left",
  FEATURE_FLAG_SCHEME_CHOICE: "feature_flag_scheme_choice",
};

module.exports = {
  VALIDATION_STATUSES,
  EVENTS,
  ELEMENTS,
  ELEMENT_FRAMES,
  STANDARD_CVV_LENGTH,
  AMEX_CVV_LENGTH,
  AMEX_SCHEME,
  FRAMES_MODES,
};
